export default __webpack_public_path__ + "static/media/partner1.4bd6eb79.svg";